// Column-width preference key, namespaced to the CURRENT USER so one tech's saved
// layout never overwrites another's on a shared machine. Falls back to email, then
// 'anon' for an unauthenticated/unknown user.
export function assetWidthStorageKey(user) {
  return `assets.colWidths.${user?.id || user?.email || 'anon'}`;
}
